import React from 'react'
import { TableProps } from 'antd/lib/table'
import moment from 'moment'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { R6Data } from 'src/store/ducks/reports/types'
import { Table, Text, Tooltip } from 'src/components/Ant'

function abbreviate(word: string, index: number) {
  return index
    ? /[A-Z]/.test(word.charAt(0))
      ? `${word.charAt(0)}.`
      : /[0-9]/.test(word.charAt(0))
      ? word
      : null
    : word
}

const columns: ColumnProps<R6Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.6.data.request-number',
    width: 50
  },
  {
    align: 'center',
    dataIndex: 'requested_on',
    key: 'requested_on',
    render: (requested_on: number) => (
      <Text>{moment.unix(requested_on).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.9.data.created-on',
    width: 60
  },
  {
    align: 'center',
    dataIndex: 'e_ticket',
    key: 'e_ticket',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.6.data.e-ticket',
    width: 60
  },
  {
    align: 'center',
    dataIndex: 'traveler',
    ellipsis: true,
    key: 'traveler',
    render: (value: string) => (
      <Tooltip title={<>{value}</>}>
        <Text>{value.split(' ').map(abbreviate).join(' ')}</Text>
      </Tooltip>
    ),
    title: 'web.report.6.data.traveler'
  },
  {
    align: 'center',
    dataIndex: 'departure_date',
    key: 'departure_date',
    render: (value: number) => (
      <Text>{moment.unix(value).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.6.data.departure-date'
  },
  {
    align: 'center',
    dataIndex: 'itinerary',
    key: 'itinerary',
    render: (value: string) => {
      switch (value) {
        case 'MULTI_STRETCH':
          return <Text title="web.air-route-itinerary.MULTI_STRETCH" />
        case 'ONE_WAY':
          return <Text title="web.air-route-itinerary.ONE_WAY" />
        case 'ROUND_TRIP':
          return <Text title="web.air-route-itinerary.ROUND_TRIP" />
        default:
          return <Text>{value}</Text>
      }
    },
    title: 'web.report.6.data.itinerary'
  },
  {
    align: 'center',
    dataIndex: 'air_destiny',
    ellipsis: true,
    key: 'air_destiny',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.6.data.air-destiny'
  },
  {
    align: 'center',
    dataIndex: 'company_iata',
    key: 'company_iata',
    render: (value: string) => {
      switch (value) {
        case 'AD':
          return <Text>AZUL</Text>
        case 'G3':
          return <Text>GOL</Text>
        case 'LA':
        case 'JJ':
          return <Text>LATAM</Text>
        default:
          return <Text>{value}</Text>
      }
    },
    title: 'web.report.6.data.company-iata'
  },
  {
    align: 'center',
    dataIndex: 'agency_name',
    ellipsis: true,
    key: 'agency_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.6.data.agency-name'
  },
  {
    align: 'right',
    dataIndex: 'tickets_total_sum',
    key: 'tickets_total_sum',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.6.data.tickets-total-sum'
  }
]

function TableDetail(props: TableProps<R6Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
